import useParamsType from 'src/hooks/useParamsType.hook'
import useCustomCookies from 'src/hooks/useCustomCookies.hook'
import { encryptPhoneNumber } from 'src/utils'
import { useChannel } from 'src/provider/ChannelContextProvider'
import { Bridge } from 'src/utils/bridge'
import { addFlowBreadcrumb } from 'src/utils/sentry/breadcrumbs'

export interface BillgatePaymentRequestProps {
  orderId: string
  payMethod?: string
  isGift?: boolean
  /**100/2011 응답 HashKey. 빌게이트 결제창 form의 HASH_KEY로만 사용**/
  hashKey?: string
  /**100/2011 요청에 넣은 ORDER_DATE. 결제창 form도 동일한 값이어야 한다**/
  orderDate?: string
}

const useBillgate = () => {
  const { couponType, couponNumber, couponIdx } = useParamsType()
  const { ios, aos, web, channel } = useChannel()
  const { c_tel } = useCustomCookies()

  // 결제창 form은 렌더 시점에 만들어지므로 GX_pay 직전에 DOM으로 주입
  const injectToPaymentForm = (name: string, value?: string) => {
    const form = document.getElementById('payment') as HTMLFormElement | null
    if (!form) return
    const existInput = form.querySelector(`input[name="${name}"]`) as HTMLInputElement | null
    if (!value) {
      existInput?.remove()
      return
    }
    if (existInput) {
      existInput.value = value
      return
    }
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  }

  //빌게이트 결제창 요청
  const handleBillgatePaymentRequest = ({
    orderId,
    payMethod,
    isGift,
    hashKey,
    orderDate,
  }: BillgatePaymentRequestProps) => {
    addFlowBreadcrumb('payment_attempt', 'request', {
      handler: 'handleBillgatePaymentRequest',
      channel: channel,
      payMethod,
      type: isGift ? 'gift' : 'default',
      hasHashKey: !!hashKey,
      hasOrderDate: !!orderDate,
    })
    switch (true) {
      case aos:
      case ios:
        const encryptPNumber = encryptPhoneNumber(c_tel)
        const searchParams = new URLSearchParams()
        if (isGift) searchParams.set('isGift', 'true')
        if (hashKey) searchParams.set('hashKey', encryptPhoneNumber(hashKey))
        if (orderDate) searchParams.set('orderDate', orderDate)
        const queryString = searchParams.toString()
        const externalUrl = `${window.location.origin}/${channel}/billgate/call/${payMethod}/${couponType}/${couponIdx}/${couponNumber}/${orderId}/${encryptPNumber}${!!queryString ? `?${queryString}` : ''}`
        Bridge.handleReqExternalOpenUrl(externalUrl)
        break
      case web:
      default:
        const frameName = 'payment'
        const viewType = 'popup'
        const protocolType = process.env.REACT_APP_PAYMENT_GXPAY_PROPTOCOLTYPE as string
        injectToPaymentForm('HASH_KEY', hashKey)
        injectToPaymentForm('ORDER_DATE', orderDate)
        window.GX_pay(frameName, viewType, protocolType)
        break
    }
  }

  return { handleBillgatePaymentRequest }
}
export default useBillgate
